export default __webpack_public_path__ + "assets/partly-cloudy-night.4aca209b.svg";